import { StyledTableCell, StyledTableRow, ActionsMenu } from 'components';
import React from 'react';
import { MenuEdit } from 'components/ActionsMenu/actions';
import { PropTypes } from 'prop-types';

const PromoterRow = ({ promoter, onEdit }) => {
    return (
        <StyledTableRow>
            <StyledTableCell>{promoter.name}</StyledTableCell>
            <StyledTableCell>
                <ActionsMenu autoClose>
                    <MenuEdit onClick={() => onEdit(promoter)} />
                </ActionsMenu>
            </StyledTableCell>
        </StyledTableRow>
    );
};

PromoterRow.propTypes = {
    promoter: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
};

export default PromoterRow;
